import * as React from 'react';
import { DataTable, Column, ColumnType, Alignment, FilterStates } from '@patterns/datatable';
import OfficesDialog from './office.dialog';
import { OfficeRepository } from '../../repository';
import { Office } from '../../models/office';

import { Notifier, Toolbar } from '@patterns/ui';
import { Button } from '@blueprintjs/core';
import { WithTranslation, withTranslation } from 'react-i18next';

const OfficesTable = DataTable.ofType<Office>();

export interface Props extends WithTranslation {}

export interface State {
  selected: Office
  showDialog: boolean
}

export class Offices extends React.Component<Props, State> {
  cancelToken: any;

  state = {
    selected: new Office({}),
    showDialog: false
  } as State

  tableRef = React.createRef<any>();

  private create = async () => {
    this.setState({
      selected: new Office({}),
      showDialog: true
    })
  }

  private getColumns = () => {
    const { t } = this.props;
    return [
      {
        id: 'id',
        title: 'ID',
        type: ColumnType.Text,
        sortable: true,
        filterable: true,
        alignment: Alignment.Left,
        width: 80,
        visible: false,
        format: office => <span>{ office.id }</span>
      },
      {
        id: 'name',
        title: t('name'),
        type: ColumnType.Text,
        alignment: Alignment.Left,
        flex: 1,
        visible: true,
        format: office => <span>{ office.name }</span>
      },
      {
        id: 'address',
        title: t('address'),
        type: ColumnType.Text,
        alignment: Alignment.Left,
        flex: 1,
        visible: true,
        format: office => <div>
          { [
            office.street, 
            office.street_2, 
            office.city, 
            office.postalCode
          ].filter(f => f).join(', ') }
        </div>
      },
      {
        id: 'lat',
        title: t('latitude'),
        type: ColumnType.Text,
        alignment: Alignment.Left,
        width: 130,
        visible: true,
        format: office => <span>{ office.lat }</span>
      },
      {
        id: 'lng',
        title: t('longitude'),
        type: ColumnType.Text,
        alignment: Alignment.Left,
        flex: 1,
        visible: true,
        format: office => <span>{ office.lng }</span>
      },
      {
        id: 'contactName',
        title: t('name'),
        type: ColumnType.Text,
        alignment: Alignment.Left,
        flex: 1,
        visible: true,
        format: office => <span>{ office.name }</span>
      },
      {
        id: 'contactEmail',
        title: t('email'),
        type: ColumnType.Text,
        alignment: Alignment.Left,
        flex: 1,
        visible: true,
        format: office => <span>{ office.name }</span>
      },
      {
        id: 'contactPhone',
        title: t('phone'),
        type: ColumnType.Text,
        alignment: Alignment.Left,
        flex: 1,
        visible: true,
        format: office => <span>{ office.name }</span>
      },
    ] as Column<Office>[]
  }

  private fetch = async (page: number, pageSize: number, sort: string, sortDir: string, filters: FilterStates) => {
    const { items, total, cancelToken } = await OfficeRepository.index(
      page, pageSize, sort, sortDir, filters, this.cancelToken
    );
    this.cancelToken = cancelToken;
    return { items, total }
  }

  private onSelect = (selected: Office) => this.setState({ 
    selected,
    showDialog: true 
  })

  private onDelete = async (office: Office) => {
    await OfficeRepository.delete(office.id);
    Notifier.success(this.props.t('settings.office_remove_success'));
    this.setState({ showDialog: false });
    this.tableRef.current?.fetch();
  }

  private onClose = () => {
    this.setState({ showDialog: false });
    this.tableRef.current?.fetch();
  }

  public render() {
    return (
      <div className="m-l-24 m-r-24">
        <Toolbar>
          <div className="f-1 jc-s ai-c d-f m-l-12">
            <Button intent="primary" text={this.props.t('settings.add_office')} icon="plus" onClick={this.create}/>
          </div>
        </Toolbar>
        
        <OfficesTable
          id="offices-table"
          ref={this.tableRef}
          columns={this.getColumns()}
          fetch={this.fetch}
          sort="id"
          sortDir="asc"
          onItemSelect={this.onSelect}
        />

        <OfficesDialog
          isOpen={this.state.showDialog}
          onClose={this.onClose}
          onDelete={this.onDelete}
          office={this.state.selected}
        />
      </div>
    );
  }
}

export default withTranslation()(Offices)